module.exports = __webpack_public_path__ + "img/SIGNIFY_LOGO_RGB@2x.c0b756ca.png";